module.exports = __webpack_public_path__ + "img/calendar.018d6c0f.svg";